import { render } from "./ToolButtons.vue?vue&type=template&id=8082b8de"
import script from "./ToolButtons.vue?vue&type=script&lang=js"
export * from "./ToolButtons.vue?vue&type=script&lang=js"

import "./ToolButtons.vue?vue&type=style&index=0&id=8082b8de&lang=css"
script.render = render

export default script